/**
 * @blockdaemon/staking-reporting-ts-client – TypeScript client for the Staking Reporting API.
 * Supports API key auth (X-API-Key header) or Bearer token auth.
 *
 * Run `npm run generate-client` first to generate the API client from the OpenAPI spec.
 */
import { Configuration } from './generated/configuration.js';
export * from './generated/index.js';
const DEFAULT_BASE_URL = 'https://svc.blockdaemon.com/reporting/staking';
/**
 * Create a configured API client. Call once at app/service init.
 * Auth is optional — omit both `apiKey` and `bearerToken` for unauthenticated access.
 */
export function createStakingClient(config = {}) {
    const { apiKey, bearerToken, baseUrl = DEFAULT_BASE_URL } = config;
    const headers = {};
    if (apiKey)
        headers['X-API-Key'] = apiKey;
    if (bearerToken)
        headers['Authorization'] = `Bearer ${bearerToken}`;
    const configuration = new Configuration({
        basePath: baseUrl,
        baseOptions: { headers },
    });
    return {
        getConfiguration: () => configuration,
    };
}
